import React from 'react';
import { Card, Avatar, Tag, Button } from 'antd';
import {
    FileTextOutlined,
    CalendarOutlined,
    DollarOutlined,
    LineChartOutlined,
    CreditCardOutlined
} from '@ant-design/icons';
import { getMonthName } from '../../../../utils/functions';
import { useHistory } from 'react-router-dom';

const EnhancedInvoicesCardView = ({
    record,
    onCardClick,
}) => {
    const history = useHistory();

    const payInvoice = (e, invoiceId) => {
        e.stopPropagation();
        history.push("/paymentInvoice?invoice=" + invoiceId);
    };

    return (
        <Card
            hoverable
            className="h-full relative"
            onClick={() => onCardClick && onCardClick(record)}
        >
            <div className="space-y-4 text-left">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3 overflow-hidden">
                        <Avatar
                            size={48}
                            className="flex-shrink-0 font-semibold text-lg !bg-primary"
                            icon={<FileTextOutlined />}
                        />
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-base mb-1 truncate">
                                {getMonthName(record.invoiceMonth)}, {record.invoiceYear}
                            </h3>
                            <p className="text-gray-500 text-sm mb-0">
                                Total: {record.totalAmount} $
                            </p>
                        </div>
                    </div>
                    <Tag
                        color={record.paymentStatus ? "success" : "error"}
                        className="m-0 font-medium px-3 py-1 rounded-full border-none"
                    >
                        {record.paymentStatus ? "Paid" : "Unpaid"}
                    </Tag>
                </div>

                {/* Metrics Info */}
                <div className="space-y-2 border-b border-gray-200 pb-3">
                    <div className="flex items-center justify-between text-sm text-gray-600">
                        <span className="flex items-center">
                            <LineChartOutlined className="mr-2" /> Leads Imported:
                        </span>
                        <span className="font-semibold text-gray-800">{record.totalLeadsImported}</span>
                    </div>
                    <div className="flex items-center justify-between text-sm text-gray-600">
                        <span className="flex items-center">
                            <DollarOutlined className="mr-2" /> Lead Price:
                        </span>
                        <span className="font-semibold text-gray-800">{record.perLeadPrice} $</span>
                    </div>
                </div>

                {/* Footer Section Section */}
                <div className="flex items-center justify-between pt-1">
                    <div className="flex flex-col">
                        <span className="text-[10px] text-gray-400 uppercase font-bold tracking-wider">Amount Due</span>
                        <span className="text-lg font-bold text-gray-900">{record.totalAmount} $</span>
                    </div>

                    {!record.paymentStatus && (
                        <Button
                            type="primary"
                            size="small"
                            icon={<CreditCardOutlined />}
                            className="!bg-primary rounded-md h-9 px-4 flex items-center gap-1 font-medium"
                            onClick={(e) => payInvoice(e, record._id)}
                        >
                            Pay Now
                        </Button>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default EnhancedInvoicesCardView;
